import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * @typedef {function} learningCenterStore
 * @property {Object} state - learningCenterStore state
 * @property {string} state.userMoodleCourses - user's Moodle courses as JSON string
 */

export const useLearningCenterStore = defineStore('learningCenterStore', {
	state: () => ({
		userMoodleCourses: useStorage('userMoodleCourses', ref(null)),
	}),
	getters: {
		/**
		 * Gets the user's Moodle courses
		 * @param {learningCenterStore.state} state
		 * @returns {string} JSON string of user Moodle course data
		 */
		getUserMoodleCourses(state) {
			return state.userMoodleCourses ? JSON.parse(state.userMoodleCourses) : null
		},
	},
	actions: {
		logout() {
			this.userMoodleCourses = null
		},

		/**
		 * Set the Moodle courses
		 * @param {string} p_moodle_courses JSON string of user Moodle courses data
		 */
		setUserMoodleCourses(p_moodle_courses)
		{
			if (typeof p_moodle_courses === 'string')
			{
				this.userMoodleCourses = p_moodle_courses
			}
			else if (typeof p_moodle_courses === 'object')
			{
				this.userMoodleCourses = JSON.stringify(p_moodle_courses)
			}
			else
			{
				this.userMoodleCourses = null
			}
		}
	},
})